<template>
  <div id="sendEnvelope">
    <mt-header fixed :title="$t('配置红包')">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
      <mt-button slot="right" @click.native="redEnvelopeRecord()"
        ><span style="color: #1296db">{{ $t("已有红包") }}</span></mt-button
      >
    </mt-header>
    <div class="container">
      <div class="photo">
        <img v-bind:src="initMessage.avatar" alt="" class="oImg" />
        <span class="currency_name">{{ initMessage.nickname }}</span>
        <div class="amount_of wx_rt" @click="changePhoto()">
          <img src="../../assets/img/coinDetail/img_qiehuan.png" alt="" />
        </div>
      </div>
      <mt-cell
        :title="coin_symbol"
        is-link
        to="/redCoinList"
        class="dl-line"
      ></mt-cell>
      <mt-cell :title="$t('金额')" class="dl-line">
        <input
          type="text"
          placeholder="0.00"
          class="int"
          v-model="total_amount"
          value="total_amount"
        />
      </mt-cell>
      <mt-cell :title="$t('红包数')" class="dl-line">
        <input
          type="text"
          :placeholder="$t('请填写个数')"
          class="int"
          v-model="total_num"
          value="total_num"
        />{{ $t("个") }}
      </mt-cell>
      <div class="dl-line" style="padding: 15px 0">
        <input
          type="text"
          v-model="wishesList"
          value="wishesList"
          class="wish"
        />
      </div>
      <!-- <mt-cell :title="wishesList" style="color:#8c92a8;"></mt-cell> -->
      <div class="footer wx_fontSize3" @click="haveRed()">
        {{ $t("生成红包") }}
      </div>
    </div>

    <!-- 发送红包相关信息显示 弹出框-->
    <div class="box" v-show="isShow">
      <div class="mag">
        <mt-cell :title="$t('发红包')">
          <span @click="close()">
            <img
              src="../../assets/img/ico_close_lan.png"
              alt=""
              style="width: 20px; height: 20px"
            />
          </span>
        </mt-cell>
        <mt-cell :title="$t('红包总额度')">
          <span>{{ total_amount }}{{ coin_symbol }}</span>
        </mt-cell>
        <mt-cell :title="$t('红包数量')">
          <span>{{ total_num }}个</span>
        </mt-cell>
        <mt-cell :title="$t('祝福语')">
          <span>{{ wishesList }}</span>
        </mt-cell>
        <div class="footer wx_fontSize3 zhifu" @click="surePay()">
          {{ $t("确认支付") }}
        </div>
      </div>
    </div>

    <div class="box" ref="box" v-show="show_pay_pwd">
      <div class="mag">
        <mt-cell :title="$t('请输入支付密码')">
          <span @click="close()">
            <img
              src="../../assets/img/ico_close_lan.png"
              alt=""
              style="width: 20px; height: 20px"
            />
          </span>
        </mt-cell>
        <div class="passContainer">
          <Password ref="pay_pass" v-on:end="onEnd"></Password>
        </div>
      </div>
    </div>

    <!-- 支付完成弹框将红包分享给朋友 -->
    <div class="box" v-show="red_envelope">
      <div class="red_main">
        <mt-cell :title="$t('选择发送途径')">
          <span @click="senRed()">
            <img
              src="../../assets/img/ico_close_lan.png"
              alt=""
              style="width: 20px; height: 20px"
            />
          </span>
        </mt-cell>
        <span class="Redmain">
          <img src="../../assets/img/red.png" alt="" />
          <span class="Redphoto"
            ><img v-bind:src="initMessage.avatar" alt=""
          /></span>
          <p class="wishes wx_fontSize2">{{ wishes.red_envelope_tips }}</p>
        </span>
        <p class="wx_fontSize2 detail">
          {{ $t("可在已有红包页面查看领取详情") }}
        </p>
        <div
          class="footer wx_fontSize3 zhifu"
          style="margin-top: 6%"
          @click="copy($event)"
        >
          {{ $t("将配好的红包分享给好友") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpRedEnvelopeInit, httpRedEnvelopeMake } from "@/api/index";
import Password from "@/components/Password";
import { validateEmpty } from "@/utils/validate";
import { share } from "@/utils/index";
import handleClipboard from "@/utils/clipboard";
export default {
  components: { Toast, Password },
  data: function () {
    return {
      cataList: [],
      initMessage: {},
      wishes: [],
      wishesList: "",
      id: "",
      coin_symbol: this.$t("选择币种"),
      total_amount: "",
      total_num: "",
      isShow: false,
      show_pay_pwd: true,
      red_envelope: false,
      wishes: {},
      password: "",
      cataData: {},
      pay: true,
    };
  },
  mounted() {
    this.initData();
  },
  activated() {
    if (this.$route.query.result) {
      this.coin_symbol = this.$route.query.result.name;
      this.id = this.$route.query.result.id;
    } else {
      this.total_amount = "";
      this.total_num = "";
    }
    this.$refs.box.style.top = "1000px";
    this.isShow = false;
    this.red_envelope = false;
    this.pay = true;
  },
  methods: {
    initData: function () {
      // 获取 红包初始化信息  用于随机祝福语 头像
      httpRedEnvelopeInit({})
        .then((res) => {
          console.log(res);
          this.cataList = res.data.nicknames.list;
          this.wishes = res.data.wishes.list;
          this.sendNum(this.cataList);
          this.sendwish(this.wishes);
        })
        .catch(() => {});
    },

    // 头像 祝福语随机
    sendNum: function (arr) {
      this.initMessage = arr[Math.floor(Math.random() * arr.length)];
    },
    sendwish: function (arr) {
      this.wishesList =
        arr[Math.floor(Math.random() * arr.length)].wish_content;
    },

    // 输入完密码后执行发红包接口
    getSubmit: function () {
      var p = {
        total_amount: this.total_amount,
        total_num: this.total_num,
        coin_symbol: this.coin_symbol,
        nickname: this.initMessage.nickname,
        wish: this.wishesList,
        passWord_pay: this.password,
      };

      // 发送红包接口  打开分享给好友弹框
      httpRedEnvelopeMake(p)
        .then((res) => {
          if (res.code == 1) {
            this.wishes = res.data;
            this.$refs.box.style.top = "1000px";
            this.red_envelope = !this.red_envelope;
            this.cataData = res.data;
          } else {
            Toast(res.msg);
          }
        })
        .catch(() => {});
    },

    // 已有红包条状配置界面
    redEnvelopeRecord() {
      this.$router.push("/redEnvelopeRecord");
    },

    // 第一步首先点击生成红包  打开发红包详情
    haveRed() {
      if (this.$store.state.userInfo.has_paypwd != 1) {
        Toast(this.$t("请先设置支付密码"));
        return;
      }
      if (
        validateEmpty(this.total_amount) ||
        validateEmpty(this.total_num) ||
        this.coin_symbol == "选择币种"
      ) {
        Toast(this.$t("empty"));
        return;
      }
      this.isShow = !this.isShow;
    },

    // 点击随机头像祝福语
    changePhoto() {
      this.initData();
    },
    close() {
      this.isShow = false;
      this.$refs.box.style.top = "1000px";
    },
    onEnd: function (val) {
      if (val.length == 6) {
        this.password = val;
        this.getSubmit();
      }
    },
    senRed() {
      this.red_envelope = !this.red_envelope;
      this.isShow = false;
      this.$refs.box.style.top = "1000px";
      this.coin_symbol = "选择币种";
      this.total_amount = "";
      this.total_num = "";
    },

    //第二部在发红包信息中确认红包  点击输密码
    surePay() {
      if (this.pay) {
        // 打开弹框 输入密码
        this.$refs.box.style.top = "0px";
        this.$refs.pay_pass.focus();
        this.$refs.pay_pass.reset();
      } else {
        this.getSubmit();
      }
      this.isShow = !this.isShow;
    },

    copy: function (event) {
      handleClipboard(
        this.cataData.red_envelope_url,
        // this.coin_symbol,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
    // 点击分享事件
    // doshare() {
    //   var p = {
    //     title: this.cataData.red_envelope_title,
    //     desp: this.cataData.red_envelope_tips,
    //     url: this.cataData.red_envelope_url,
    //   };
    //   console.log(p);
    //   // 使用share分享工具
    //   share(JSON.stringify(p));
    // },
  },
};
</script>

<style scoped>
#sendEnvelope {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mint-header {
  background: #fff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.container {
  padding: 50px 0px 10px 0px;
}
.swiper {
  height: 80px;
}
.photo {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 10px;
}
.swiper img {
  width: 100%;
  max-height: 100%;
  border-radius: 10px;
}
input::-ms-input-placeholder {
  text-align: right;
}
input::-webkit-input-placeholder {
  text-align: right;
}
.int {
  padding-right: 15px;
  text-align: right;
  color: #212529;
}
.photo {
  border-bottom: 1px solid #f6f6f6;
  width: 100%;
  position: relative;
  height: 50px;
  overflow: hidden;
}
.oImg {
  width: 40px;
  height: 40px;
  border: 1px solid #dddddd;
  border-radius: 50%;
  margin: 5px 10px;
}
.currency_name {
  position: relative;
  display: inline-block;
  top: -15px;
}
.amount_of {
  width: 20%;
  text-align: right;
  padding: 10px 0;
  text-align: center;
  color: #1296db;
}
.amount_of img {
  width: 22px;
  height: 22px;
}

.footer {
  width: calc(100% - 20px);
  height: 50px;
  background: #1296db;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-top: 20px;
  border-radius: 0px;
  margin-left: 10px;
}

.zhifu {
  width: calc(100% - 30px);
  margin-left: 15px;
  margin-top: 40px;
}
.box {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mag {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #fff;
  height: 36%;
}
.passContainer {
  margin-top: 30px;
}
.red_main {
  position: absolute;
  top: 17%;
  background: #fff;
  height: 66%;
  width: 90%;
  margin-left: 5%;
  border-radius: 5px;
  padding: 5px 0 0 0;
}
.Redmain {
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  position: relative;
  height: 55%;
}
.Redmain img {
  width: 80%;
  height: 100%;
  position: relative;
}
.detail {
  color: #666;
  text-align: center;
  margin-top: 10px;
}
.Redmain .Redphoto {
  position: absolute;
  width: 40px;
  height: 40px;
  left: calc(50% - 20px);
  top: 62px;
}
.Redmain .Redphoto img {
  width: 100%;
  height: 100%;
  border: 4px solid #fff;
  border-radius: 50%;
}
.wishes {
  width: 60%;
  margin-left: 20%;
  text-align: center;
  color: #fff;
  position: absolute;
  bottom: 20%;
}
.wish {
  padding-left: 20px;
  font-weight: 600;
  font-size: 16px;
}
.dl-line {
  border-bottom: 1px solid #f6f6f6;
}
</style>
